import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import MuiTextField from '@mui/material/TextField';
import Section from 'components/Section';
import TextField from 'components/TextField';
import CitySelect from 'components/CitySelect';
import TwoColumn from 'components/TwoColumn';

import { HotelEditMainGeneral_data$key } from '__generated__/HotelEditMainGeneral_data.graphql';
import StarSelect from 'components/StarSelect';
import { HotelEditMainGeneral_hotel$key } from '__generated__/HotelEditMainGeneral_hotel.graphql';

type Props = {
  hotel: HotelEditMainGeneral_hotel$key;
  data: HotelEditMainGeneral_data$key;
};

const HotelEditMainGeneral: FC<Props> = props => {
  const { source, externalId } = useFragment(
    graphql`
      fragment HotelEditMainGeneral_hotel on Hotel {
        source
        externalId
      }
    `,
    props.hotel
  );

  const data = useFragment(
    graphql`
      fragment HotelEditMainGeneral_data on Query {
        ...CitySelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="general" title="Bendra informacija">
      <Stack spacing={4}>
        <TextField name="name" label="Pavadinimas" />
        <CitySelect name="city" label="Miestas" data={data} />

        <TwoColumn
          left={
            <TextField
              fullWidth
              name={`location.lat`}
              label="Platuma (Latitude)"
            />
          }
          right={
            <TextField
              fullWidth
              name={`location.lng`}
              label="Ilguma (Longitude)"
            />
          }
        />

        <StarSelect name="stars" />

        {source === 'ETG' && (
          <MuiTextField
            disabled
            variant="standard"
            value={externalId}
            label="ID išorinėje sistemoje"
          />
        )}
      </Stack>
    </Section>
  );
};

export default HotelEditMainGeneral;
